/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import {
  ConfirmButtonActions,
  InternalInvoiceReport,
  Reportedperiod /*, ReportedPeriodReportType*/,
} from "./editTypes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReportPreview } from "./ReportPreview";
import { ToolTipContainer } from "./ToolTipContainer";
import { Contract } from "../../services/API/Contracts";
import { Department } from "../../services/API/Departments";

interface Props {
  selectedState: { [key: number]: { period: string; show: boolean } };
  data: InternalInvoiceReport;
  reportedPeriods: { [key: string]: Reportedperiod[] };
  item: any;
  handleSelectedReportForInvoiceDateChange: (
    period: string,
    item: any,
    index: number,
    reportType: "InvoiceReport" | "NullReport",
    action: ConfirmButtonActions,
    supplierOrgId: string,
    batchId?: string,
    departmentId?: number,
  ) => void;
  index: number;
  contract: Contract[];
  departments?: Department[];
}
export const EditTableToolTip = ({
  selectedState,
  data,
  reportedPeriods,
  item,
  handleSelectedReportForInvoiceDateChange,
  index,
  contract,
  departments,
}: Props) => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selected, setSelected] = React.useState<boolean>(
    /*selectedState[index].show*/ false,
  );
  const [show, setShow] = React.useState<boolean>();
  const [tooltipContent, setTooltipContent] =
    React.useState<JSX.Element | null>(null);
  const [dep, setDep] = React.useState<number>(data?.departmentId ?? -1);
  const [showDepartments, setShowDepartments] = React.useState<boolean>(false);
  const [errorIncompatiableReport, setErrorIncompatiableReport] =
    React.useState<boolean>(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    updateTooltip();
  }, [selectedState, selected, dep, showDepartments, errorIncompatiableReport]);
  React.useEffect(() => {
    if (!show) {
      setTooltipContent(null);
      setShowDepartments(false);
      setShow(false);
    }
  }, [show]);
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      // If the dropdownRef exists and the click target is not within it, close the dropdown
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDepartments(false);
      }
    };

    // Add event listeners for both mouse and touch events
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  /**
   * Toggles the selection state and updates the report selection for invoice date change.
   * @param period - The selected period.
   * @param item - The item being selected.
   * @param index - The index of the item.
   * @param reportType - The type of report being handled.
   * @param batchId - (Optional) The batch ID associated with the report.
   */
  const handleSelected = (
    period: string,
    item: any,
    reportType: "InvoiceReport" | "NullReport",
    action: ConfirmButtonActions,
    supplierOrgId: string,
    child: boolean,
    batchId?: string,
    departmentId?: number,
  ) => {
    //console.log('*****************värden i handleSelected******************',{period,item,reportType,action,supplierOrgId,batchId,departmentId})

    if (!errorIncompatiableReport) {
      if (child) {
        handleSelectedReportForInvoiceDateChange(
          period,
          item,
          index,
          reportType,
          action,
          supplierOrgId,
          batchId,
          departmentId,
        );
      } else {
        setSelected((prev) => {
          const newSelected = !prev;
          handleSelectedReportForInvoiceDateChange(
            period,
            item,
            index,
            reportType,
            newSelected ? "PUSH" : "POP",
            supplierOrgId,
            batchId,
            dep == -1 ? departmentId : dep,
          );
          return newSelected;
        });
      }
    } else {
      return false;
    }
  };
  /**
   * Validates if the provided date falls within the contract's valid period.
   * @param contractId - The ID of the contract.
   * @param newDate - The date being checked.
   * @returns A tuple where the first value is a boolean indicating validity,
   *          and the second is a JSX element displaying an error message if invalid.
   */
  const checkContractDateValidity = (
    contractId: string,
    newDate: string,
  ): [boolean, JSX.Element] => {
    if (contractId.length > 0) {
      const contracts = contract.find((x: any) => x.contractId == contractId);
      if (typeof contracts !== "undefined") {
        const contractStart = contracts?.reportingFromDate?.toLocaleDateString(
          "sv-SE",
          { year: "numeric", month: "2-digit" },
        ) as string;
        if (newDate < contractStart) {
          return [
            false,
            <>Datumet ligger utanför startdatum för valt kontrakt.</>,
          ];
        }
        return [true, <></>];
      }
      return [false, <>Fältet AvtalsId får inte vara tomt.</>];
    } else {
      return [false, <>Fältet AvtalsId får inte vara tomt.</>];
    }
  };

  const renderDepartmentSelection = (): JSX.Element | null => {
    if (typeof departments !== "undefined" && departments?.length > 0) {
      return (
        <>
          <p style={{ margin: 0 }}>Raden saknar ett tilldelat avdelnings-ID.</p>
          <p style={{ margin: 0 }}>
            Du kan antingen ange ett avdelnings-ID eller lämna fältet tomt.
          </p>
          <p style={{ margin: 0 }}>Leverantören kan välja bland följande </p>
          <div ref={dropdownRef} className="departmentDropDown">
            <button
              className="departmentDropDownBtn"
              onClick={() => setShowDepartments(!showDepartments)}
            >
              Avdelningar
            </button>
            <div
              className="departmentDropDown-content"
              style={{ display: showDepartments ? "block" : "none" }}
            >
              <p
                style={{ borderBottom: dep == -1 ? "1px solid white" : "" }}
                onClick={() => {
                  setDep(-1);
                  if (selected !== false) {
                    setSelected(false);
                  }
                }}
              >
                ingen avdelning
                {dep == -1 && (
                  <FontAwesomeIcon
                    icon={"circle-check"}
                    style={{
                      position: "relative",
                      left: "10px",
                      cursor: "pointer",
                      color: "rgb(146, 192, 31)",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      border: "2px solid white",
                    }}
                  />
                )}
              </p>
              {departments?.map((x) => {
                return (
                  <p
                    style={{
                      borderBottom: dep == x.id ? "1px solid white" : "",
                    }}
                    onClick={() => {
                      setDep(x.id);
                      if (selected !== false) {
                        setSelected(false);
                      }
                    }}
                  >
                    {x.department}
                    {dep == x.id && (
                      <FontAwesomeIcon
                        icon={"circle-check"}
                        style={{
                          position: "relative",
                          left: "10px",
                          cursor: "pointer",
                          color: "rgb(146, 192, 31)",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          border: "2px solid white",
                        }}
                      />
                    )}
                  </p>
                );
              })}
            </div>
          </div>
        </>
      );
    }
    return null;
  };
  const checkReport = (period: string, reportType: string) => {
    const check = reportedPeriods[period].find((x) => x.type == reportType);
    if (typeof check !== "undefined" && check.csrd !== data.csrd) {
      setErrorIncompatiableReport(true);
      // console.log('BAJS BAJS BAJS')
    } else {
      setErrorIncompatiableReport(false);
    }
  };
  /**
   * Updates the tooltip content based on the selected invoice date change.
   * Displays relevant messages and actions depending on the report type and date validity.
   */
  const updateTooltip = () => {
    // console.log(selectedState,index)
    const invoiceDateChangedToPeriod: string | null =
      index == Object.keys(selectedState).length
        ? null
        : selectedState[index].period;
    if (!invoiceDateChangedToPeriod) {
      if (show) setShow(false);
      setTooltipContent(null);
      return;
    }
    const invoicesFrom = data.invoicesFrom.toLocaleDateString("sv-SE", {
      year: "numeric",
      month: "2-digit",
    });
    const invoicesTo = data.invoicesTo.toLocaleDateString("sv-SE", {
      year: "numeric",
      month: "2-digit",
    });
    const filterdPeriod = reportedPeriods[invoiceDateChangedToPeriod]?.filter(
      (x) => x.type == "InvoiceReport" || x.type == "NullReport",
    );
    // console.log(filterdPeriod)
    let text: JSX.Element | null = null;
    if (
      invoiceDateChangedToPeriod < invoicesFrom ||
      invoiceDateChangedToPeriod > invoicesTo
    ) {
      const dateValidity = checkContractDateValidity(
        item["contractId"],
        invoiceDateChangedToPeriod,
      );
      if (dateValidity[0]) {
        if (typeof reportedPeriods[invoiceDateChangedToPeriod] == "undefined") {
          text = (
            <ToolTipContainer
              anchorRef={anchorRef}
              onClose={() => {
                setShow(false);
                setSelected(false);
              }}
            >
              {renderDepartmentSelection()}
              <p style={{ margin: 0 }}>
                Ändringen kommer att skapa upp en ny rapport för{" "}
                {invoiceDateChangedToPeriod}
              </p>
              <p style={{ margin: 0 }}>
                Glöm inte att skicka in kickbackrapporten som skapas upp efter
                att alla ändringar är inskickade.
              </p>

              <div
                className="checkYeah"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  borderTop: "1px solid white",
                  marginTop: 5,
                }}
              >
                <p
                  style={{
                    marginLeft: 4,
                    marginRight: 0,
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                  }}
                >
                  Bekräfta
                </p>
                <FontAwesomeIcon
                  onClick={() =>
                    handleSelected(
                      invoiceDateChangedToPeriod,
                      item,
                      "InvoiceReport",
                      "PUSH",
                      item.supplierOrgId,
                      false,
                      undefined,
                      item.departmentId,
                    )
                  }
                  icon="square-check"
                  style={{
                    cursor: "pointer",
                    color: selected ? "rgb(146, 192, 31)" : "rgba(179, 4, 4)",
                    height: 20,
                    width: 20,
                  }}
                />
              </div>
            </ToolTipContainer>
          );

          //return text;
        } else if (
          reportedPeriods[invoiceDateChangedToPeriod].filter(
            (x) => x.type == "NullReport",
          ).length == 1
        ) {
          text = (
            <ToolTipContainer
              anchorRef={anchorRef}
              onClose={() => {
                setShow(false);
                setSelected(false);
              }}
            >
              {renderDepartmentSelection()}

              <p style={{ margin: 0 }}>
                Ändringen kommer att ta bort nollrapporteringen för{" "}
                {invoiceDateChangedToPeriod}.
              </p>
              <p style={{ margin: 0 }}>
                Samt skapa upp en ny statistikrapport.
              </p>
              <p style={{ margin: 0 }}>
                Glöm inte att skicka in kickbackrapporten som skapas upp efter
                att alla ändringar är inskickade.
              </p>
              <div
                className="checkYeah"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  borderTop: "1px solid white",
                  marginTop: 5,
                }}
              >
                <p
                  style={{
                    marginLeft: 4,
                    marginRight: 0,
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                  }}
                >
                  Bekräfta
                </p>
                <FontAwesomeIcon
                  onClick={() =>
                    handleSelected(
                      invoiceDateChangedToPeriod,
                      item,
                      "NullReport",
                      "PUSH",
                      item.supplierOrgId,
                      false,
                      undefined,
                      item?.departmentId,
                    )
                  }
                  icon="square-check"
                  style={{
                    cursor: "pointer",
                    color: selected ? "rgb(146, 192, 31)" : "rgba(179, 4, 4)",
                    height: 20,
                    width: 20,
                  }}
                />
              </div>
            </ToolTipContainer>
          );
        } else {
          text =
            filterdPeriod?.length > 1 ? (
              <ToolTipContainer
                anchorRef={anchorRef}
                onClose={() => {
                  setShow(false);
                  setSelected(false);
                }}
              >
                <ReportPreview
                  departments={departments}
                  index={index}
                  period={invoiceDateChangedToPeriod}
                  item={item}
                  departmentId={data?.departmentId}
                  data={filterdPeriod}
                  onSelected={
                    handleSelected /*handleSelectedReportForInvoiceDateChange*/
                  }
                />
              </ToolTipContainer>
            ) : (
              <ToolTipContainer
                anchorRef={anchorRef}
                onClose={() => {
                  setShow(false);
                  setSelected(false);
                }}
              >
                {renderDepartmentSelection()}
                {dep == data.departmentId ||
                (dep == -1 && data.departmentId == null) ? (
                  <>
                    <p style={{ margin: 0 }}>
                      Hittade en statistikrapport för valt datum
                    </p>
                    <p style={{ margin: 0 }}>
                      flyttar fakturarad till statistikrapport för{" "}
                      {invoiceDateChangedToPeriod}.
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{ margin: 0 }}>
                      Valt avdelnings id har ingen statistikrapport
                      inrapporterad för valt datum.
                    </p>
                    <p style={{ margin: 0 }}>
                      Kommer att skapa upp en ny statistikrapport för vald
                      period och avdelning.
                    </p>
                  </>
                )}

                <div
                  className="checkYeah"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    borderTop: "1px solid white",
                    marginTop: 5,
                  }}
                >
                  <p
                    style={{
                      marginLeft: 4,
                      marginRight: 0,
                      marginTop: 0,
                      marginBottom: 0,
                      padding: 0,
                    }}
                  >
                    Bekräfta
                  </p>
                  <div
                    style={{ position: "relative" }}
                    onMouseLeave={() => setErrorIncompatiableReport(false)}
                    onMouseEnter={() =>
                      checkReport(invoiceDateChangedToPeriod, "InvoiceReport")
                    }
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "0%",
                        right: "120%",
                        display: errorIncompatiableReport ? "flex" : "none",
                        flexDirection: "row",
                        width: "185px",
                        justifyContent: "center",
                        backgroundColor: "rgb(179, 4, 4)",
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        {" "}
                        Vald rapport går inte att flytta till
                      </p>
                    </div>
                    <FontAwesomeIcon
                      onClick={
                        () =>
                          handleSelected(
                            invoiceDateChangedToPeriod,
                            item,
                            "InvoiceReport",
                            "PUSH",
                            item.supplierOrgId,
                            false,
                            dep == data.departmentId ||
                              (dep == -1 && data.departmentId == null)
                              ? filterdPeriod[0].batchId
                              : undefined,
                            item?.departmentId,
                          ) /*handleSelectedReportForInvoiceDateChange(invoiceDateChangedToPeriod,item,index,filterdPeriod[0].batchId)*/
                      }
                      icon="square-check"
                      style={{
                        cursor: "pointer",
                        color: selected
                          ? "rgb(146, 192, 31)"
                          : "rgba(179, 4, 4)",
                        height: 20,
                        width: 20,
                      }}
                    />
                  </div>
                </div>
              </ToolTipContainer>
            );
        }
      } else {
        text = (
          <ToolTipContainer
            anchorRef={anchorRef}
            onClose={() => setShow(false)}
          >
            {dateValidity[1]}
          </ToolTipContainer>
        );
      }
      setTooltipContent(text);
      setShow(true);
    } else {
      setShow(false);
      setTooltipContent(null);
    }
    return <>{show && tooltipContent}</>;
  };
  return (
    <div ref={anchorRef} style={{ display: "inline-block" }}>
      {tooltipContent}
    </div>
  );
};
